//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { commonApi } from "@/common/index";
export default {
  name: "Texas",
  data() {
    return {
      pokerUrl: "",
      platformCode: "Poker",
      platformKey: "Poker_CHESS",
      gameType: "6",
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      langs: (state) => state.langs,
    }),
  },
  activated() {
    this.getPokerUrl();
  },
  watch: {
    isLogin: {
      handler() {
        if (this.$route.path === "/texas") {
          this.getPokerUrl();
        }
      },
    },
  },
  methods: {
    getPokerUrl() {
      const params = {
        UUID: this.UUID,
        linkType: 1,
        platformCode: this.platformCode,
        platformKey: this.platformKey,
        gameType: this.gameType,
      };

      commonApi.GAME.getGameUrl(this.isLogin, params).then((res) => {
        if (res.code === 200) {
          this.pokerUrl = res.data;
        } else {
          this.$toast({
            message: res.msg || res.message,
            icon: "warning",
          });
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/texas/index.vue